<template lang="pug">
  ui-hero(fullheight)
    .container: .columns: .column.is-4.is-offset-4(@keyup.enter="onLogin")
      transition(name="fade" appear): div
        .panel.has-shadow.is-grey

          .panel-heading
            span.has-text-grey-dark.mr-10 Сфера
            span.has-text-grey Бизнес-обучение

          .panel-content.has-background-light
            .columns
              .column
                validation-observer(v-slot="{ invalid }")
                  ui-field.mb-20(v-model="authEmail" placeholder="E-mail" rules="required|email" icon="email" :disabled="inProgress")
                  ui-field(v-model="authPassword" type="password" placeholder="Пароль" rules="required" icon="key" :disabled="inProgress")
                  b-field.control.has-text-centered
                    button.button.is-primary(@click="onLogin" :class="{'is-loading':inProgress}" :disabled="invalid") Войти

</template>

<script>
import api from '@/api';
import { mapMutations } from 'vuex';
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'form-auth',

  data: () => ({
    auth: false,
    inProgress: false,
    authEmail: '',
    authPassword: '',
    errors: {
      email: null,
      password: null,
    },
  }),

  methods: {
    ...mapMutations(['setUser']),

    onLogin() {
      this.inProgress = true;
      this.errors = {};
      api
        .login(this.authEmail, this.authPassword)
        .then(() => {
          api.user().then(({ data }) => {
            Toast.open({
              message: 'Вы авторизованы!',
              type: 'is-success',
            });
            this.inProgress = false;
            this.setUser(data);
          });
        })
        .catch(({ message, validation }) => {
          this.inProgress = false;
          if (validation) {
            this.errors.email = validation.email ? validation.email[0] : null;
            this.errors.password = validation.password ? validation.password[0] : null;
          } else if (message) {
            Toast.open({
              message,
              duration: 5000,
              type: 'is-danger',
            });
          }
        });
    },
  },
};
</script>
